"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _intlDesignUi = require("@tencent/intl-design-ui");
var _data = require("./data");
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const isMockData = false;
const TCE_DATA_COS_URL = '/render/api/configsolution/tceTableInfo';
const formatTable = properties => {
  const _properties$paginatio = properties.paginationOpts,
    paginationOpts = _properties$paginatio === void 0 ? {} : _properties$paginatio,
    _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? [] : _properties$configura; // 第一条数据是模块名称
  const list = configuration.map((item, index) => {
    return _objectSpread(_objectSpread({}, item), {}, {
      key: index + 1
    });
  });
  return {
    configuration: list,
    paginationOpts: {
      placeholder: paginationOpts.placeholder || '',
      pageText: paginationOpts.pageText || '',
      goText: paginationOpts.goText || '',
      resetText: paginationOpts.resetText || '',
      sureText: paginationOpts.sureText || '',
      versionText: paginationOpts.versionText || '',
      featureText: paginationOpts.featureText || '',
      downloadText: paginationOpts.downloadText || '',
      downloadTitle: paginationOpts.downloadTitle || '',
      pageSize: Number(paginationOpts.pageSize) || 5
    }
  };
};

// 处理数据
const doReq = (list, lang, defaultLang = 'en') => {
  let leftOptiosData = [];
  leftOptiosData = list.filter(item => item.language === lang);
  if (leftOptiosData && leftOptiosData.length === 0) {
    // 数据为空用英文兜底
    leftOptiosData = list.filter(item => item.language === defaultLang);
  }
  return leftOptiosData;
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  lang = 'en'
}) {
  if (Object.keys(data).length > 1) {
    const _formatTable = formatTable(data),
      paginationOpts = _formatTable.paginationOpts,
      configuration = _formatTable.configuration;
    const _React$useState = React.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      psData = _React$useState2[0],
      setPSData = _React$useState2[1];
    const bgStyle = {
      padding: 0
    };
    React.useEffect(() => {
      _axios.default.get(TCE_DATA_COS_URL).then(({
        data: result
      }) => {
        const _result$data = result.data,
          list = _result$data === void 0 ? [] : _result$data,
          code = result.code;
        if (code === 0) {
          const tceData = doReq(list, lang, 'en');
          setPSData(tceData);
        } else {
          const data = _data.dataResult.data;
          const tceData = doReq(data, lang, 'en');
          setPSData(tceData);
        }
      }).catch(e => {
        // 出错时用mock数据兜底，避免报错
        const data = _data.dataResult.data;
        const tceData = doReq(data, lang, 'en');
        setPSData(tceData);
      });
    }, []);
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(_intlDesignUi.Section, {
      style: bgStyle
    }, /*#__PURE__*/React.createElement(_intlDesignUi.TabTceTable, {
      configuration: configuration,
      data: psData,
      paginationOpts: paginationOpts
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}